export default __webpack_public_path__ + "static/media/defense_client.205c93cc.png";